(function () {
  var header = document.querySelector('.header-section');
  if (!header) {
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 1067px)');
  var THRESHOLD = 80;
  var DELTA = 6;
  var lastY = window.scrollY || window.pageYOffset || 0;
  var ticking = false;

  function update() {
    ticking = false;

    if (!mobileQuery.matches) {
      header.classList.remove('lop-header--hidden');
      lastY = window.scrollY || window.pageYOffset || 0;
      return;
    }

    if (document.body.classList.contains('overflow-hidden')) {
      lastY = window.scrollY || window.pageYOffset || 0;
      return;
    }

    var y = window.scrollY || window.pageYOffset || 0;

    if (Math.abs(y - lastY) < DELTA) {
      return;
    }

    if (y > lastY && y > THRESHOLD) {
      header.classList.add('lop-header--hidden');
    } else {
      header.classList.remove('lop-header--hidden');
    }

    lastY = y;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  var toggle = document.querySelector('.mobile-toggle-wrapper');
  if (toggle) {
    var lockedY = 0;
    var isLocked = false;

    function lockScroll() {
      if (isLocked) {
        return;
      }
      lockedY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -lockedY + 'px';
      document.body.classList.add('lop-scroll-locked');
      isLocked = true;
    }

    function unlockScroll() {
      if (!isLocked) {
        return;
      }
      document.body.classList.remove('lop-scroll-locked');
      document.body.style.top = '';
      isLocked = false;

      var htmlEl = document.documentElement;
      var prevBehavior = htmlEl.style.scrollBehavior;
      htmlEl.style.scrollBehavior = 'auto';
      window.scrollTo(0, lockedY);
      htmlEl.style.scrollBehavior = prevBehavior;

      lastY = lockedY;
      header.classList.remove('lop-header--hidden');
    }

    new MutationObserver(function () {
      if (toggle.classList.contains('active')) {
        lockScroll();
      } else {
        unlockScroll();
      }
    }).observe(toggle, { attributes: true, attributeFilter: ['class'] });
  }
})();
